module.exports = __webpack_public_path__ + "media/images/favicon-801f5c963a973f4adfb17a95fa229596.ico";